
import _set from 'lodash/set';

export const searchStore = {
    state: {
        filter: {},
    },
    getters: {
        filter: (state) => state.filter,
    },
    mutations: {
        initFilter(state, filter) {
            state.filter = filter;
        },
        updateFilter(state, keyValue) {
            _set(state.filter, keyValue.key, keyValue.value);
        },
    },
    actions: {
        applyFilter({commit}, keyValue) {
            commit('updateFilter', keyValue);
        },
    },
};
